<h2 mat-dialog-title>{{ data.title ?? 'Create agreement' }}</h2>

<mat-dialog-content>
  <div class="entity-form">
    <mat-form-field>
      <mat-label>Client Code</mat-label>
      <input matInput [formField]="form.ClientCode" [matAutocomplete]="ccAutocomplete.autocomplete()" #ccInput />
      <lcm-autocomplete #ccAutocomplete="lcmAutocomplete" [options]="clientCodes()" [pattern]="ccInput.value" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>
        @if (form.JobNumber().value() && !form.JobNumber().valid()) {
          <mat-icon class="mat-text-error" matTooltip="Product number does not belong to specified client"
            >error</mat-icon
          >
        }
        Product Number
      </mat-label>
      <input matInput [formField]="form.JobNumber" [matAutocomplete]="jnAutocomplete.autocomplete()" #jnInput />
      <lcm-autocomplete #jnAutocomplete="lcmAutocomplete" [options]="jobNumbers()" [pattern]="jnInput.value" />
    </mat-form-field>

    @if (form.AgreementNumber().value()) {
      <mat-form-field>
        <mat-label> Agreement Number </mat-label>
        <input matInput [formField]="form.AgreementNumber" />
      </mat-form-field>
    }

    <mat-form-field>
      <mat-label> Service Type </mat-label>
      <mat-select [formField]="form.ServiceType">
        @for (code of serviceTypes(); track code) {
          <mat-option [value]="code">{{ code }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="agreementRangePicker">
        <input matStartDate required placeholder="Start date" [formField]="form.StartDate" />
        <input matEndDate required placeholder="End date" [formField]="form.EndDate" />
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="agreementRangePicker"></mat-datepicker-toggle>
      <mat-date-range-picker #agreementRangePicker></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Billing Cycle </mat-label>
      <mat-select [formField]="form.BillingCycle">
        @for (code of billingCycles(); track code) {
          <mat-option [value]="code">{{ code }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Status </mat-label>
      <mat-select [formField]="form.Status">
        @for (code of statuses(); track code) {
          <mat-option [value]="code">{{ code }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Total Contract Cost </mat-label>
      <input matInput type="number" [formField]="form.InvoiceAmount" step="0.01" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Infrastructure Amount </mat-label>
      <input matInput type="number" [formField]="form.HostingAmount" step="0.01" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Service Amount </mat-label>
      <input matInput type="number" [formField]="form.ServiceAmount" step="0.01" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Support & Maintenance Amount </mat-label>
      <input matInput type="number" [formField]="form.SupportMaintenanceAmount" step="0.01" />
    </mat-form-field>

    <mat-checkbox [formField]="form.HasSLA">Has SLA</mat-checkbox>

    <mat-form-field>
      <mat-label> Support Hours </mat-label>
      <input matInput type="number" [formField]="form.SupportHours" />
      @if (form.HasSLA().value()) {
        <mat-hint>Must be greater than 0</mat-hint>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label> Expiration period </mat-label>
      <mat-select [formField]="form.ExtendedLifetime">
        <mat-option [value]="false">3 months</mat-option>
        <mat-option [value]="true">12 months</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Jira Licenses </mat-label>
      <input matInput type="number" [formField]="form.JiraLicence" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Title </mat-label>
      <input matInput [formField]="form.Title" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Product Owner </mat-label>
      <input matInput [formField]="form.ProductOwner" [matAutocomplete]="poAutocomplete.autocomplete()" #poInput />
      <lcm-autocomplete #poAutocomplete="lcmAutocomplete" [options]="productOwners()" [pattern]="poInput.value" />
    </mat-form-field>

    <label>
      Documents
      <input
        type="file"
        accept=".pdf,.jpeg,.png,.doc,.docx,.xslx"
        multiple
        (change)="uploadDocuments($event.target.files)"
      />
    </label>

    <mat-list>
      @for (document of form.Documents().value(); track document.DocumentId) {
        <mat-list-item>
          <span matListItemTitle> {{ document.DocumentName }} </span>

          <div matListItemMeta class="cell-actions">
            <button matMiniFab (click)="removeDocument(document)" color="warn">
              <mat-icon>remove</mat-icon>
            </button>
            <button matMiniFab (click)="downloadDocument(document)">
              <mat-icon>remove_red_eye</mat-icon>
            </button>
          </div>
        </mat-list-item>
      }
    </mat-list>

    <mat-checkbox [formField]="form.Commissionable">Commissionable</mat-checkbox>
    <mat-form-field>
      <mat-label> Notes </mat-label>
      <textarea matInput [formField]="form.Notes"></textarea>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Hours/budget note </mat-label>
      <input matInput [formField]="form.BudgetNote" />
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matMiniFab matTooltip="Save product details" (click)="save()" [disabled]="!form().valid() || pending()">
    <mat-icon>save</mat-icon>
  </button>
</mat-dialog-actions>
@if (pending()) {
  <mat-progress-bar mode="indeterminate" />
}
